import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  input,
  signal,
  Signal,
  WritableSignal
} from '@angular/core';
import {AssemblyFrameInput} from "../models/assembly-frame-input";
import {AssemblySpacingInput} from "../models/spacing-input";
import {AssemblyFrameComponent} from "./components/assembly-frame/assembly-frame.component";
import {AssemblySpacingComponent} from "./components/assembly-spacing/assembly-spacing.component";
import {LamelareaImpl} from "../../shared/product-card/product-card/lamelarea.class";

@Component({
  selector: 'app-assembly-graphical-configurator',
  standalone: true,
  imports: [
    AssemblySpacingComponent,
    AssemblyFrameComponent
  ],
  templateUrl: './assembly-graphical-configurator.component.html',
  styles:  ":host{ @apply flex w-full h-full block overflow-hidden; }",
})
export class AssemblyGraphicalConfiguratorComponent implements AfterViewInit {
  private elementRef: ElementRef<any> = inject(ElementRef);

  /**
   * signal to provide the width of the host element
   */
  protected hostWidth: WritableSignal<number> = signal(this.elementRef.nativeElement.clientWidth);

  public lamellaArea = input<LamelareaImpl>()

  protected span = computed(()=>  this.lamellaArea()?.orientation === 'horizontal'? this.lamellaArea()?.width: this.lamellaArea()?.height  )

  /**
   * Signal to provide the frame positions
   * @protected
   */
  protected framePositions: Signal<any> = computed(() => this.lamellaArea()?.framePositions ?? []);

  /**
   * Signal to provide the relative frame positions
   * @protected
   */
  protected relativeFramePositions = computed(()=>
      this.lamellaArea()?.framePositions.map((item: any, idx) => ({
              index: idx*2+1,
              position: item.position / this.span() * this.hostWidth()
          })
      ) ?? []
  );

  /**
   * Signal to provide the relative span widths
   * @protected
   */
  protected relativeSpanWidth = computed(()=>
      this.lamellaArea()?.assemblyArray?.filter(this.isSpacingInput)
          ?.map((item: any) => ({
              index: item.index,
              position: item.span / this.span() * this.hostWidth()
          }) ?? []
      )
  )

  /**
   * provide host element width to signal after view init
   */
  ngAfterViewInit() {
    this.hostWidth.set(this.elementRef.nativeElement.clientWidth);
  }

  /**
   * update the hostWidth signal on window resize
   * @param event
   */
  @HostListener('window:resize', ['$event']) onWidthChange(event: Event) {
    this.hostWidth.set(this.elementRef.nativeElement.clientWidth);
  }

  /**
   * filtering function
   * @param object
   */
  public isSpacingInput(object: any): object is AssemblySpacingInput { return (object as AssemblySpacingInput).span !== undefined}

  /**
   * filtering function
   * @param object
   */
  public isFrameSpanInput(object: any): object is AssemblyFrameInput { return (object as AssemblyFrameInput).hasReinforcement !== undefined}

  /**
   * get the relative position of the frame
   * @param index
   */
  relativePosition(index: number){
    return this.relativeFramePositions().find((item) => item.index === index)?.position ?? 0;
  }

  /**
   * get the relative span width of the spacing
   * @param index
   */
  relativeSpan(index: number){
    return (this.relativeSpanWidth().find((item: any) => item.index === index) as any)?.position ?? 0;
  }


}
